
import PropTypes from 'prop-types';
import Toast from '../components/Toast/Toast';

/**
 * Utility method to generate a toast to be passed to the `addToast` action creator.
 * @param {node} node - toast content to be rendered
 * @param {object} props - props for the <Toast />
 * @returns {object} toast
 * @example
 * ```
 * const myToast = toast((<MyComponent />), {autoClose: false});
 * addToast(myToast);
 *
 * const myTextToast = toast('I love toast!');
 * addToast(myTextToast);
 * ```
 */
export const toast = (node, props = {}) => {
    // generate the id here, so that we can expose it to consumers
    // for programmatic toast removal
    const id = Date.now();

    // construct the toast props
    const toastProps = {
        ...props,
        content: node,
        id
    };

    // generate a warning in development if props are invalid
    PropTypes.checkPropTypes(Toast.propTypes, toastProps);

    return toastProps;
};

export default toast;